import MfaSetupBackup from './MfaSetupBackup';

export default MfaSetupBackup;